import Vue from 'vue'
import Router from 'vue-router'
import RegRouter from '@/components/Engine/Base/RegRouter'

import ViewLogin from '@/components/Main/Viewform/Login/Page'

import $ from "jquery";

Vue.use(Router);

const router = new Router({
  routes: [
    // 首页跳转登录页
    {
      path: '/',
      redirect: '/main/viewform/login'
    },
    {
      path: '/main/viewform/login',
      name: 'ViewLogin',
      component: ViewLogin
    },
    {
      path: '/engine/base/regrouter',
      name: 'RegRouter',// 注册动态路由
      component: RegRouter
    },
  ],
// 采用历史模式，可去掉地址栏的【#】
  mode: 'history',
});

router.beforeEach((to, from, next) => {
  let octopus = router.app.octopus;
  console.log("Index.js路由：" + from.path + " ==> " + to.path + ", octopus.route: " + to.fullPath);

  // 如果当前页面不在整个路由中，则进入。
  if (to.matched.length === 0) {
    // console.log(octopus);
    // 如果是刷新进入，则借助RegRouter  中转页面注册。
    if (!octopus) {
      console.log("刷新页面进入，此时没有八抓鱼，所以需要跳转 RegRouter 进行引导注册。");
      next({
        // path: "/helloword",
        name: "RegRouter",
        query: {url: to.fullPath},
      });
    }
    // 正常跳转将获得 octopus 对象，可以注册
    else {
      octopus.router.register(to.fullPath, function (data) {
        if (data.status.code == 200) {
          next({
            path: to.fullPath,
          });
        } else {
          octopus.tips.error("网络出现问题，请重新尝试。");
          console.error(JSON.stringify(data.status));
        }
      });
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  // 执行新页面的动画效果，页面默认不显示，然后出现动画，每次加载渲染都会在template引擎模块中设置为隐藏。
  Vue.nextTick(function () {
    $("[o-container-app]").animate({
      opacity: "1",
      // left: "100px",
      // width: "100px",
      // height: 300
    });
  })
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js